import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { NavService } from '../../_services/_nav.service';
import { Table } from 'primeng/table';
import { ConfiguracionUrlExterna } from '../../_models/configuracion-url-externa';
import { Router } from '@angular/router';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { Producto } from '../../_models/producto';
import { ProductoAlerta } from '../../_models/producto-alerta';
import { forkJoin } from 'rxjs';
import { ProductoAlertaGrupoService } from '../../_services/producto-alerta-grupo.service';
import { ProductoAlertaGrupoCondicionService } from '../../_services/producto-alerta-grupo-condicion.service';
import { ProductoAlertaGrupo } from '../../_models/producto-alerta-grupo';
import { ProductoAlertaGrupoCondicion } from '../../_models/producto-alerta-grupo-condicion';
import { ListaService } from '../../_services/lista.service';
import { AutenticacionService } from '../../_services/autenticacion.service';
import { ListaItem } from '../../_models/lista-item';
import { AlertaService } from '../../_services/alerta.service';
import { AppSettingService } from '../../_services/app-setting.service';

@Component( {
  selector: 'app-producto-alerta-configuracion',
  templateUrl: 'producto-alerta-configuracion.component.html'
} )

export class ProductoAlertaConfiguracionComponent implements OnInit {

  @Input() producto:Producto;
  @Input() visualizar:boolean;
  @Input() productoAlerta:ProductoAlerta;

  public listaAlertaGrupos:ProductoAlertaGrupo[] = [];
  public listaCondiciones:SelectItem[] = [];
  public listaTiposCampo:ListaItem[] = [];

  public carInformacionInicial:boolean = true;
  public showDlgCondiciones:boolean = false;
  public productoGrupo:ProductoAlertaGrupo;
  public codigoTipoCampoDefault:string;

  // Modal Condiciones grupo
  formCondiciones = {
    productoGrupo: null,
    listaCondicionesAgregar: [] as ProductoAlertaGrupoCondicion[],
    condicionesSubmitted: false,
    validandoCondiciones: false,
    validando: false
  };

  //Variables del datatable
  public numRegistros: number;
  public buscando: boolean;
  public columnas: any[] = [];

  public codigoGrupo: string;
  public grupoSubmitted: boolean = false;

  constructor(private prodAlertaGrupoService:ProductoAlertaGrupoService,
              private prodAlertaGrupoCondicionesService:ProductoAlertaGrupoCondicionService,
              private listaService:ListaService,
              private navService:NavService,
              private authService:AutenticacionService,
              private alertaService:AlertaService,
              private confirmService:ConfirmationService,
              public appSettingService: AppSettingService){
  }

  ngOnInit(): void {
    this.inicializarTabla();
    this.getListas();
  }

  /**
   * Obtiene las listas que se usaran en el formulario para agregar condiciones a la alerta
   * Obtiene la lista de los grupos de condiciones habilitados para el producto alerta actual
   * */
  private getListas(){
    forkJoin(
      /*this.prodAlertaGrupoService.listadoHabilitadosPorIdProductoAlerta(this.productoAlerta.idProductoAlerta),*/
      this.prodAlertaGrupoService.listadoPorIdProductoAlerta(this.productoAlerta.idProductoAlerta),
      this.listaService.getMasterDetails("ListasCondiciones"),
      this.listaService.getMasterDetails("ListasTiposValoresCampos")
    ).subscribe(([alertaGrupos, listaCondiciones, listaTiposValoresCampos]) => {

      listaCondiciones.forEach( c => {
        const item = {value: c.idLista, label:c.nombre};
        this.listaCondiciones.push(item);
      });

      this.listaTiposCampo = listaTiposValoresCampos;
      if ( listaTiposValoresCampos && listaTiposValoresCampos.length > 0 ){
        this.codigoTipoCampoDefault = listaTiposValoresCampos[0].codigo;
      }

      this.listaAlertaGrupos = alertaGrupos;
      this.carInformacionInicial = false;
      this.buscando = false;
    }, e => {
      console.log(e);
      this.carInformacionInicial = false;
      this.listaCondiciones = [];
      this.listaTiposCampo = [];
      this.listaAlertaGrupos = [];
    });
  }


  /**
   * Obtiene la lista de los grupos de condiciones habilitados para el producto alerta actual
   * */
  private getGruposCondiciones(){
    this.prodAlertaGrupoService.listadoPorIdProductoAlerta(this.productoAlerta.idProductoAlerta).subscribe( grupos => {
      this.listaAlertaGrupos = grupos;
    }, e => {
      console.log(e);
      this.listaAlertaGrupos = [];
    });
  }


  /**
   * Inicializa el formulario de las condiciones
   * */
  private inicializarFormulario(prodGrupo?:any){
    this.formCondiciones = {
      productoGrupo: prodGrupo,
      listaCondicionesAgregar: [] as ProductoAlertaGrupoCondicion[],
      condicionesSubmitted: false,
      validandoCondiciones: false,
      validando: false
    }
  }

  /**
   * Inicializa la cabecera de la tabla de las condiciones de los grupos
   * */
  private inicializarTabla(){

    this.columnas = [
      { field: 'operador', header: this.navService.buscarMensaje( 'PRODUCTOSALERTA.LBL_OPERADOR' ), sort: false },
      { field: 'tipocampo', header: this.navService.buscarMensaje( 'PRODUCTOSALERTA.LBL_TIPOCAMPO' ), sort: false },
      { field: 'valor', header: this.navService.buscarMensaje( 'PRODUCTOSALERTA.LBL_VALOR' ), sort: false },
    ];
  }

  /**
   * Abre el modal con el formulario para crear nuevo grupo de condiciones
   * */
  public agregarNuevoGrupo(){
    this.inicializarFormulario(null);
    this.productoGrupo = null;
    this.codigoGrupo = null;
    this.showDlgCondiciones = true;
  }

  /**
   * Obtiene el objeto del grupo a editar y abre el modal con los datos del grupo a editar
   * */
  public editarGrupo(idProductoAlertaGrupo:string){
    const prodGrupo = this.listaAlertaGrupos.find(x => x.idProductoAlertaGrupo === idProductoAlertaGrupo);

    if ( prodGrupo ){
      this.productoGrupo = prodGrupo;
      this.codigoGrupo = prodGrupo.codigo;
      this.inicializarFormulario(prodGrupo);
      this.asignarItemsListaAgregar(prodGrupo.productosAlertasGruposCondiciones);
      this.formCondiciones.productoGrupo = prodGrupo;
      setTimeout(() => {
        this.showDlgCondiciones = true;
      }, 800);
    } else {
      this.productoGrupo = null;
      this.codigoGrupo = null;
    }

  }

  /**
   * Asigna los valores correspondientes a las condiciones de un grupo que se va a editar
   * */
  private asignarItemsListaAgregar(listaBase:ProductoAlertaGrupoCondicion[]){
    listaBase.map( c => {
      if ( c.indicadorHabilitado ){
        const tipoCampoObj = this.listaTiposCampo.find(x => x.idLista === c.idTipoValorCampo);
        const condicion = {
          idProductoAlertaGrupoCondicion: c.idProductoAlertaGrupoCondicion,
          idProductoAlertaGrupo: c.idProductoAlertaGrupo,
          idTipoValorCampo: c.idTipoValorCampo,
          valorCondicion: c.valorCondicion,
          idCondicion: c.idCondicion,
          auditoriaFecha: c.auditoriaFecha,
          auditoriaUsuario: c.auditoriaUsuario,
          indicadorHabilitado: true,
          codigoTipoCampo: tipoCampoObj ? tipoCampoObj.codigo : null,
          objTipoCampoValor: tipoCampoObj ? tipoCampoObj : null,
        } as ProductoAlertaGrupoCondicion;

        this.formCondiciones.listaCondicionesAgregar.push(condicion);
      }
    });
  }

  /**
   * agrega un item de condicion despues de validar ciertos criterios
   * */
  public agregarCondicion(){
    if ( this.validateCondiciones() ){
      const condicion = {
        idProductoAlertaGrupoCondicion: null,
        idProductoAlertaGrupo: this.productoGrupo ? this.productoGrupo.idProductoAlertaGrupo : null,
        idTipoValorCampo: null,
        valorCondicion: null,
        idCondicion: null,
        auditoriaFecha: null,
        auditoriaUsuario: this.authService.obtenerIdUsuarioLogueado(),
        indicadorHabilitado: true,
        codigoTipoCampo: this.codigoTipoCampoDefault,
        objTipoCampoValor: null
      } as ProductoAlertaGrupoCondicion;

      this.formCondiciones.listaCondicionesAgregar.push(condicion);
    }
  }

  /**
   * Valida que todas las condiciones agregadas cumplan con los criterios requeridos para las condiciones
   * Valida que no existan condiciones con llaves de negocio identicas
   * */
  public validateCondiciones(){
    if ( this.formCondiciones.listaCondicionesAgregar.length > 0 && !this.formCondiciones.validando) {
      this.formCondiciones.validandoCondiciones = true;
      this.formCondiciones.validando = true;
      for ( let i = 0; i < this.formCondiciones.listaCondicionesAgregar.length; i++ ) {
        const cond = this.formCondiciones.listaCondicionesAgregar[i];
        if ( this.validarDuplicado(cond) ){
          this.formCondiciones.validando = false;
          this.navService.setMesage( 0,
            {
              severity: 'info',
              summary: this.navService.buscarMensaje( 'LBL_INFORMACION' ),
              detail: this.navService.buscarMensaje( 'PRODUCTOSALERTA.MSG_CONDICIONESDUPLICADAXLLAVES' )
            } );
          return false;
        } else {
          if ( cond.indicadorHabilitado && (!cond.idCondicion || cond.valorCondicion === null || !cond.idTipoValorCampo)) {
            this.formCondiciones.validando = false;
            return false;
          }

          if ( i ===  (this.formCondiciones.listaCondicionesAgregar.length - 1) ){
            this.formCondiciones.validando = false;
            this.formCondiciones.validandoCondiciones = false;
            return true;
          }
        }
      }
    } else {
      return true;
    }
  }

  /**
   * Valida si una condicion esta duplicada
   * */
  private validarDuplicado(obj:any){
    const duplicados = this.formCondiciones.listaCondicionesAgregar.filter(x => x.idCondicion === obj.idCondicion && x.idTipoValorCampo === obj.idTipoValorCampo && x.indicadorHabilitado);
    if ( duplicados && duplicados.length > 1 ){
      return true;
    } else {
      return false;
    }
  }

  /**
   * Elimina una condicion del array de condiciones de un grupo
   * */
  public eliminarCondicion(condIndex:number){
    this.formCondiciones.listaCondicionesAgregar.splice(condIndex, 1);
  }

  /**
   * Abre un modal para confirmar o rechazar el guardado de datos
   * */
  public onSubmit(){
    this.formCondiciones.condicionesSubmitted = true;
    this.grupoSubmitted = true;
    this.confirmService.confirm( {
      message: this.navService.buscarMensaje( 'PRODUCTOSALERTA.MSG_CONFIRMACIONGRUPOCONDICIONES' ),
      header: this.navService.buscarMensaje( 'LBL_CONFIRMACION' ),
      icon: 'fa fa-question-circle',
      accept: () => {
        this.guardarCondiciones();
      },
      reject: () => {
        this.formCondiciones.condicionesSubmitted = false;
      }
    } );
  }

  /**
   * Realiza el guardado o actualizacion en base de datos, del grupo de condiciones despues de realizar las validaciones correspondientes
   * */
  public guardarCondiciones(){
    //validar lista condiciones
    //validar duplicados
    //validar si es edicion o creacion
    //inhabilitar las condiciones

    if ( this.validateCondiciones() ){
      if ( !this.productoGrupo || this.productoGrupo && !this.productoGrupo.idProductoAlertaGrupo ) {
        if ( this.codigoGrupo ) {
          if ( this.formCondiciones.listaCondicionesAgregar.length > 0 ) {
            this.guardarGrupoCondiciones();
          } else {
            this.navService.setMesage( 0,
              {
                severity: 'info',
                summary: this.navService.buscarMensaje( 'LBL_INFORMACION' ),
                detail: this.navService.buscarMensaje( 'PRODUCTOSALERTA.MSG_AGREGUECONDICIONES' )
              } );
            this.formCondiciones.validandoCondiciones = false;
            this.formCondiciones.condicionesSubmitted = false;
          }
        } else {
          this.formCondiciones.validandoCondiciones = false;
          this.formCondiciones.condicionesSubmitted = false;
        }
      } else {
        this.actualizarGrupoCondiciones(this.productoGrupo);
      }
    } else {
      this.formCondiciones.condicionesSubmitted = false;
    }
  }

  /**
   * Guarda un grupo de condiciones
   * */
  private guardarGrupoCondiciones() {
    const grupoGuardar = {
      idProductoAlertaGrupo: null,
      indicadorHabilitado: true,
      codigo: this.codigoGrupo,
      idProductoAlerta: this.productoAlerta.idProductoAlerta,
      auditoriaFecha: null,
      auditoriaUsuario: null
    } as ProductoAlertaGrupo;

    this.prodAlertaGrupoService.obtenerPorIdProductoAlertaYCodigo(this.productoAlerta.idProductoAlerta, this.codigoGrupo).subscribe( resp => {
      if ( resp ) {
        if ( resp.indicadorHabilitado ) {
          this.navService.setMesage( 0,
            {
              severity: 'info',
              summary: this.navService.buscarMensaje( 'LBL_INFORMACION' ),
              detail: this.navService.buscarMensaje( 'PRODUCTOSALERTA.MSG_CODIGOGRUPODUPLICADO' )
            } );
          this.formCondiciones.condicionesSubmitted = false;
        } else {
          grupoGuardar.idProductoAlertaGrupo = resp.idProductoAlertaGrupo;
          this.actualizarGrupoCondiciones(grupoGuardar);
        }
      } else {

        this.prodAlertaGrupoService.crear(grupoGuardar).subscribe( grupo => {
          if ( grupo ) {
            this.formCondiciones.listaCondicionesAgregar.forEach( c => {
              c.idProductoAlertaGrupo = grupo.idProductoAlertaGrupo;
            });
            this.prodAlertaGrupoCondicionesService.crearBulk(this.formCondiciones.listaCondicionesAgregar).subscribe( response => {
              this.navService.setMesage( 0,
                {
                  severity: 'success',
                  summary: this.navService.buscarMensaje( 'LBL_INFORMACION' ),
                  detail: this.navService.buscarMensaje( 'PRODUCTOSALERTA.MSG_GRUPOCONDICIONESGUARDADO' )
                } );
              this.getGruposCondiciones();
              this.showDlgCondiciones = false;
              this.grupoSubmitted = false;
            }, e => {
              console.log(e);
              this.formCondiciones.condicionesSubmitted = false;
              this.navService.setMesage( 0,
                {
                  severity: 'error',
                  summary: this.navService.buscarMensaje( 'LBL_ERROR' ),
                  detail: this.navService.buscarMensaje( 'PRODUCTOSALERTA.MSG_ERRORALGUARDAR' )
                } );
            });
          }
        });
      }
    });
  }

  actualizarGrupoCondiciones(group: ProductoAlertaGrupo) {
    if ( this.formCondiciones.listaCondicionesAgregar.length > 0 ) {
      //this.productoGrupo.indicadorHabilitado = true;
      group.indicadorHabilitado = true;
    } else {
      //this.productoGrupo.indicadorHabilitado = false;
      group.indicadorHabilitado = false;
    }

    this.prodAlertaGrupoService.actualizar(group).subscribe( grupo => {
      if ( grupo && grupo.indicadorHabilitado ) {
        grupo.productosAlertasGruposCondiciones = this.getCondicionesGrupo(grupo.idProductoAlertaGrupo);
        const listaGuardar = this.armarListaCondicionesGuardar(this.formCondiciones.listaCondicionesAgregar, grupo);
        this.prodAlertaGrupoCondicionesService.crearBulk(listaGuardar).subscribe( response => {
          this.navService.setMesage( 0,
            {
              severity: 'success',
              summary: this.navService.buscarMensaje( 'LBL_INFORMACION' ),
              detail: this.navService.buscarMensaje( 'PRODUCTOSALERTA.MSG_GRUPOCONDICIONESACTUALIZADO' )
            } );
          this.getGruposCondiciones();
          this.showDlgCondiciones = false;
          this.grupoSubmitted = false;

        }, e => {
          this.formCondiciones.condicionesSubmitted = true;
        });

      } else if ( grupo && !grupo.indicadorHabilitado ) {
        // llamar servicio para inhabilitar condiciones
        this.prodAlertaGrupoService.inhabilitarAlertaGrupo(grupo.idProductoAlertaGrupo).subscribe( r => {
          this.getGruposCondiciones();
          this.showDlgCondiciones = false;

          this.navService.setMesage( 0,
            {
              severity: 'success',
              summary: this.navService.buscarMensaje( 'LBL_INFORMACION' ),
              detail: this.navService.buscarMensaje( 'PRODUCTOSALERTA.MSG_GRUPOCONDICIONESELIMINADO' )
            } );
          this.grupoSubmitted = false;
        });
      }
    }, e => {
      this.formCondiciones.condicionesSubmitted = true;
    });
  }

  /**
   * Arma la lista final con los items de condiciones que van a ser registrados en base de datos revisando tanto en la lista de agregados como en la lista original
   * */
  private armarListaCondicionesGuardar(listaAgregar: ProductoAlertaGrupoCondicion[], grupo: ProductoAlertaGrupo) {
    let listaGuardar = [];

    if ( this.productoGrupo ) {

      listaAgregar.map( c => {
        const temp = this.productoGrupo.productosAlertasGruposCondiciones.find(x => x.idCondicion === c.idCondicion && x.idTipoValorCampo === c.idTipoValorCampo );
        if ( !temp ) {
          c.idProductoAlertaGrupo = grupo.idProductoAlertaGrupo;
          listaGuardar.push(c);
        } else {
          c.idProductoAlertaGrupo = grupo.idProductoAlertaGrupo;
          c.idProductoAlertaGrupoCondicion = temp.idProductoAlertaGrupoCondicion;
          c.idTipoValorCampo = temp.idTipoValorCampo;
          c.idCondicion = temp.idCondicion;
          listaGuardar.push(c);
        }
      });

      this.productoGrupo.productosAlertasGruposCondiciones.map( c => {
        const temp = listaGuardar.find(x => x.idProductoAlertaGrupoCondicion === c.idProductoAlertaGrupoCondicion );
        if ( !temp ) {
          c.indicadorHabilitado = false;
          c.idProductoAlertaGrupo = grupo.idProductoAlertaGrupo;
          listaGuardar.push(c);
        }
      });

      return listaGuardar;
    } else {
      if ( grupo.productosAlertasGruposCondiciones.length > 0 ) {
        listaAgregar.map( c => {
          const temp = grupo.productosAlertasGruposCondiciones.find(x => x.idCondicion === c.idCondicion && x.idTipoValorCampo === c.idTipoValorCampo );
          if ( !temp ) {
            c.idProductoAlertaGrupo = grupo.idProductoAlertaGrupo;
            listaGuardar.push(c);
          } else {
            c.idProductoAlertaGrupo = grupo.idProductoAlertaGrupo;
            c.idProductoAlertaGrupoCondicion = temp.idProductoAlertaGrupoCondicion;
            c.idTipoValorCampo = temp.idTipoValorCampo;
            c.idCondicion = temp.idCondicion;
            listaGuardar.push(c);
          }
        });

        grupo.productosAlertasGruposCondiciones.map( c => {
          const temp = listaGuardar.find(x => x.idProductoAlertaGrupoCondicion === c.idProductoAlertaGrupoCondicion );
          if ( !temp ) {
            c.indicadorHabilitado = false;
            c.idProductoAlertaGrupo = grupo.idProductoAlertaGrupo;
            listaGuardar.push(c);
          }
        });
      } else {
        listaAgregar.forEach( c => {
          c.idProductoAlertaGrupo = grupo.idProductoAlertaGrupo;
          listaGuardar.push(c);
        });
      }

      return listaGuardar;
    }
  }

  /**
   * Cierra el modalde grupo de condiciones
   * */
  public cerrarDialogoCondiciones(){
    let msg = 'PRODUCTOSALERTA.MSG_CANCELARGRUPOCONDICIONESCREAR';
    if ( this.productoGrupo && this.productoGrupo.idProductoAlertaGrupo ){
      msg = 'PRODUCTOSALERTA.MSG_CANCELARGRUPOCONDICIONESEDITAR';
    }

    this.confirmService.confirm( {
      message: this.navService.buscarMensaje( msg ),
      header: this.navService.buscarMensaje( 'LBL_CONFIRMACION' ),
      icon: 'fa fa-question-circle',
      accept: () => {
        this.showDlgCondiciones = false;
        this.grupoSubmitted = false;
        this.codigoGrupo = null;
      },
      reject: () => {
      }
    } );
  }

  /**
   * Establece el tipo de input para el campo de valor de la condicion con su configuracion correspondiente
   * */
  public cambiarInputValor(objTipoCampo:any, condIndex:number){
    this.formCondiciones.listaCondicionesAgregar[condIndex].valorCondicion = null;
    const codigoTemp = this.listaTiposCampo.find(x => x.idLista === objTipoCampo.idLista);
    this.formCondiciones.listaCondicionesAgregar[condIndex].codigoTipoCampo = codigoTemp.codigo;
    this.formCondiciones.listaCondicionesAgregar[condIndex].idTipoValorCampo = codigoTemp.idLista;
  }

  private getCondicionesGrupo(idProductoAlertaGrupo: string) {
    const grupo = this.listaAlertaGrupos.find(x => x.idProductoAlertaGrupo === idProductoAlertaGrupo);
    return grupo ? grupo.productosAlertasGruposCondiciones : [];
  }
}
